/**
 * React Starter Kit for Firebase
 * https://github.com/kriasoft/react-firebase-starter
 * Copyright (c) 2015-present Kriasoft | MIT License
 */

import React from "react";
import { History } from "history";

import { canUseDOM } from "../utils/env";

const loadScrollPositions = (): Map<string, number> => {
  if ("sessionStorage" in window) {
    const saved = sessionStorage.getItem("scrollPositions");

    if (saved) {
      return new Map(JSON.parse(saved));
    }
  }
  return new Map();
};

const saveScrollPositions = () =>
  "sessionStorage" in window &&
  sessionStorage.setItem(
    "scrollPositions",
    JSON.stringify(Array.from(scrollPositions)),
  );

const updateScrollPosition = () => {
  if (history) {
    scrollPositions.set(history.location.key, last_known_scroll_position);
  }
};

const scrollPositions = loadScrollPositions();

let last_known_scroll_position = 0;
let ticking = false;
let history: History = null;
let ready = false;

if (canUseDOM) {
  window.addEventListener("scroll", () => {
    last_known_scroll_position = window.scrollY;
    if (!ticking && ready) {
      window.requestAnimationFrame(() => {
        updateScrollPosition();
        ticking = false;
      });
      ticking = true;
    }
  });
}

export const HistoryContext = React.createContext<History>(null);

export function useHistory(): History {
  return React.useContext(HistoryContext);
}

const historyListener: any = (_, action) => {
  ready = false;

  saveScrollPositions();
};

export function setHistory(_history: History) {
  if (!history) {
    _history.listen(historyListener);
  }

  history = _history;
}
